import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { ClipboardList, AlertTriangle, ChevronRight, RefreshCw } from 'lucide-react'
import api from '../api'
import { Badge } from '../components/ui'

const jenisLabel = { GNG: 'Gangguan', PSB: 'Pasang Baru', CAB: 'Cabut', REL: 'Relokasi', UPG: 'Upgrade', PME: 'Pemeliharaan', PSG: 'Pasang Perangkat', OPT: 'Optik', SRV: 'Survey' }
const statusTone = { OPEN: 'warning', PROSES: 'brand' }

export default function PekerjaanListPublik() {
  const { token } = useParams()
  const [list, setList] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => { load() }, [token])

  function load() {
    setLoading(true)
    api.get(`/pekerjaan-list/${token}`)
      .then(res => setList(res.data.list))
      .catch(err => setError(err.response?.data?.message || 'Gagal memuat daftar'))
      .finally(() => setLoading(false))
  }

  function linkFor(item) {
    return item.tipe === 'GANGGUAN' ? `/tiket/${item.token}` : `/pekerjaan-list/${token}/${item.id}`
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '20px 16px 40px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <ClipboardList size={22} color="var(--brand)" />
          <h1 style={{ fontSize: 18, fontWeight: 800, color: 'var(--text)' }}>List Pekerjaan</h1>
          <button onClick={load} title="Muat ulang" style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 6 }}>
            <RefreshCw size={16} />
          </button>
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 18 }}>
          Semua pekerjaan yang masih berjalan (gangguan, PSB, dan jenis lainnya) — belum ditandai selesai. Ketuk salah satu untuk update status.
        </p>

        {loading && <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: 30 }}>Memuat...</p>}

        {error && (
          <div style={{ textAlign: 'center', padding: 30 }}>
            <AlertTriangle size={28} color="var(--danger)" style={{ marginBottom: 8 }} />
            <p style={{ color: 'var(--text)', fontWeight: 600 }}>{error}</p>
          </div>
        )}

        {list && list.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-faint)' }}>
            <ClipboardList size={30} strokeWidth={1.5} style={{ marginBottom: 8, opacity: 0.6 }} />
            <p>Tidak ada pekerjaan outstanding — semua sudah beres.</p>
          </div>
        )}

        {list && list.map(item => (
          <Link key={`${item.tipe}-${item.id}`} to={linkFor(item)} style={{ textDecoration: 'none' }}>
            <div style={{
              background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12,
              padding: 14, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 10
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                  <Badge tone="neutral">{jenisLabel[item.jenis] || item.jenis}</Badge>
                  <Badge tone={statusTone[item.status] || 'neutral'}>{item.status}</Badge>
                  {item.teknisi && <span style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{item.teknisi}</span>}
                </div>
                <div style={{ fontWeight: 700, color: 'var(--text)', fontSize: 14 }}>{item.lokasi}</div>
                {item.ringkas && <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 2 }}>{item.ringkas}</div>}
                {item.catatanTerakhir && <div style={{ fontSize: 11.5, color: 'var(--text-faint)', marginTop: 3 }}>Catatan: {item.catatanTerakhir}</div>}
              </div>
              <ChevronRight size={18} color="var(--text-faint)" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
